import React, { useEffect, useState, useRef } from 'react';
import { Helmet } from "react-helmet";
import { useCookies } from 'react-cookie';
import GetServiceNameImagePath from "./GetServiceNameImagePath";
import { Link } from 'react-router-dom';

function MatchResult(props) {
  const { k_id, war_id, myKDName, myPoints, matchDetails, war_data, oppKDName, myKDTotal, oppKDTotal } = props;

  //  const items = Array.from({ length: 5 });

  const myScore = war_data?.my_total ?? 0;
  const oppScore = war_data?.opp_total ?? 0;

  const isTie = myScore === oppScore;
  const isMyWinner = myScore > oppScore;
  //const isOppWinner = oppScore > myScore;

  const [myTeamImage, setMyTeamImage] = useState(null);
  const [oppTeamImage, setOppTeamImage] = useState(null);
  // const [winningText, setWinningText] = useState('');



  // const OVERRIDES = {
  //   'mbni-warriors': 'M.B.N.I-WARRIORS',
  // };

  const makeVariants = (name) => {
    // 1) Strip any character that isn't alphanumeric, space, or hyphen
    const sanitized = name
      .trim()
      .replace(/[^A-Za-z0-9\s-]/g, '');

    // 2) Collapse whitespace into single hyphens
    const base = sanitized.replace(/\s+/g, '-');  // "Vidharb Lions" → "Vidharb-Lions"

    // lookup key is lowercase
    const key = base.toLowerCase();

    // 3) If there's an override, use it
    // if (OVERRIDES[key]) {
    //   return [OVERRIDES[key]];   // e.g. "M.B.N.I-WARRIORS"
    // }

    // 4) Otherwise return just the ALL‑CAPS slug
    return [base.toUpperCase()];  // e.g. "VIDHARB-LIONS"
  };

  function useSlugImage(name) {
    const variants = useRef([]);
    const [idx, setIdx] = useState(0);
    const [src, setSrc] = useState(null);

    const getUrl = (slug) =>
      `${process.env.PUBLIC_URL}/images/BOR/borteamlogos/${slug}.png`;

    useEffect(() => {
      if (!name) return;

      // generate only-uppercase slug(s)
      variants.current = makeVariants(name);
      setIdx(0);
      setSrc(getUrl(variants.current[0]));
    }, [name]);

    const handleError = () => {
      const next = idx + 1;
      if (next < variants.current.length) {
        setIdx(next);
        setSrc(getUrl(variants.current[next]));
      }
    };

    // still returns [src, onError]
    return [src, handleError];
  }

  // usage remains the same:
  const [mySrc, myOnErr] = useSlugImage(myKDName || '');
  const [oppSrc, oppOnErr] = useSlugImage(war_data?.opp_kd_name || '');

  // compute winning text (unchanged)…
  const [winningText, setWinningText] = useState('');
  useEffect(() => {
    if (war_data?.my_total != null && war_data?.opp_total != null) {
      const diff = Math.abs(myScore - oppScore);
      if (diff === 0) {
        setWinningText(`${myKDName} & ${oppKDName} drew the match`);
      } else {
        const winnerName = isMyWinner ? myKDName : oppKDName;
        setWinningText(<>{winnerName} won by <b className="boldpoint">{diff}</b></>);
      }
    }
  }, [myScore, oppScore, myKDName, oppKDName]);

  // ——— NEW: decide left/right team ———
  const leftTeam = isTie || isMyWinner
    ? { name: myKDName, src: mySrc, onError: myOnErr, points: myKDTotal }
    : { name: oppKDName, src: oppSrc, onError: oppOnErr, points: oppKDTotal };

  const rightTeam = isTie || isMyWinner
    ? { name: oppKDName, src: oppSrc, onError: oppOnErr, points: oppKDTotal }
    : { name: myKDName, src: mySrc, onError: myOnErr, points: myKDTotal };



  useEffect(() => {
    // Add the animation for the VS image to move to final position
    const vsImage = document.getElementById('image2');
    const contentContainer = document.querySelector('.content-container');
    const animationSection = document.querySelector('.animation-section');
    const image3 = document.getElementById('image3');
    const image1 = document.getElementById('image1');

    // const timer1 = setTimeout(() => {
    //   if (vsImage) {
    //     vsImage.style.animation = 'fadeIn 0.5s forwards, moveVsToFinal 1s 2s forwards';
    //   }
    // }, 100);



    // Show content after animations complete (3 seconds for animations + 0.5s delay)
    const timer2 = setTimeout(() => {
      if (image3) {
        // Add a class that will keep the image properly positioned after container resize
        image3.classList.add('final-position');
      }



      if (contentContainer) {
        // Make the content container visible first
        contentContainer.style.display = 'block';

        // Force reflow to ensure display change is applied before we add the fade-in class
        void contentContainer.offsetWidth;

        // Then add the fade-in class to trigger the opacity transition
        setTimeout(() => {
          contentContainer.classList.add('fade-in');
        }, 50);
      }
    }, 3000);

    // 3) Right after that, reset *all* three images to static flow
    // const timer3 = setTimeout(() => {
    //   [image1, vsImage, image3].forEach(el => {
    //     if (el) el.style.setProperty('position', 'static', 'important');
    //   });
    // }, 3000 + 500); //

    return () => {
      // clearTimeout(timer1);
      clearTimeout(timer2);
      // clearTimeout(timer3);
    };
  }, []);

  return (
    <>
      <Helmet
        link={[{
          rel: "stylesheet",
          href: "css/MatchResult.css"
        }]}

      />
      <div className='warscore-innercontainerleftMatchResult'>
        <div className="main-container">
          <div className="animation-section layout-col">
            <div className='blue-bg'></div>
            <div className='red-bg'></div>
            <div className="image" id="image1">
              {/* <img src="/images/BOR/borteamlogos/BANGALORE-BULLS.png" alt="Delhi Spartans" /> */}
              {/* {myTeamImage && <img src={myTeamImage} alt={myKDName} />} */}
              {/* {myKDName && (
                <img
                  src={mySrc}
                  onError={myOnErr}
                  alt={`${myKDName} logo`}

                />
              )} */}
              {leftTeam.name && (
                <img
                  src={leftTeam.src}
                  onError={leftTeam.onError}
                  alt={`${leftTeam.name} logo`}
                />
              )}
              <div className='myteam-points'>
                <img src="../images/BOR/points-coins.png" alt="Winner Logo" className="winner-logo" />
                <span className='myteam-points-text'>{leftTeam.points}</span>

              </div>
            </div>
            <div className="image" id="image2">
              <img src="/images/BOR/borteamlogos/VSimg.png" alt="VS" />
            </div>
            <div className="image" id="image3">
              {/* <img src="/images/BOR/borteamlogos/BELAGAVI-BULLS.png" alt="Magadh Panthers" /> */}
              {/* {oppTeamImage && <img src={oppTeamImage} alt={war_data.opp_kd_name} />} */}
              {/* {oppTeamImage && <img src={oppTeamImage} alt={oppKDName} />} */}
              {/* {war_data?.opp_kd_name && (
                <img
                  src={oppSrc}
                  onError={oppOnErr}
                  alt={`${war_data.opp_kd_name} logo`}

                />
              )} */}
              {rightTeam.name && (
                <img
                  src={rightTeam.src}
                  onError={rightTeam.onError}
                  alt={`${rightTeam.name} logo`}
                />
              )}
              <div className='oppteam-points'>
                <img src="../images/BOR/points-coins.png" alt="Winner Logo" className="winner-logo" />
                <span className='myteam-points-text'>{rightTeam.points}</span>

              </div>
            </div>

          </div>

          <div className="content-container">
            <div className="winner-declaration">
              <span className="wintitle" >{winningText}</span>
              <img src="../images/BOR/points-coins.png" alt="Winner Logo" className="winner-logo" />
            </div>
            <div className="drawer-header">
              <span
                className={
                  isTie
                    ? 'team-name tie'
                    : 'team-name winner'
                }
              >
                {leftTeam.name}
              </span>
              <span
                className={
                  isTie
                    ? 'team-name tie'
                    : 'team-name'
                }
              >
                {rightTeam.name}
              </span>
            </div>
            <div className="bottom-drawer-result">

              {matchDetails}

            </div>
          </div>
        </div>
      </div>

    </>
  );
}

export default MatchResult;